import React from 'react';

interface ApplicationLinkProps {
  url: string | null;
  buttonText: string;
  onClick: () => void;
}

function ApplicationLink(
  props: ApplicationLinkProps
): React.JSX.Element | null {
  const { url, buttonText, onClick } = props;

  if (!url) {
    return null;
  }
  return (
    <a
      className="ctaButton ctaButton--applicationLink"
      data-track-click="click apply"
      data-testid="ctaButton--applicationLink"
      href={url}
      target="_blank"
      rel="noreferrer noopener"
      onClick={onClick}
      onAuxClick={onClick}
      onContextMenu={onClick}
    >
      {buttonText}
    </a>
  );
}

export default ApplicationLink;
